export default __webpack_public_path__ + "static/media/zootodo_001.3b687ca2.png";